// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".o7CRax0a8AqwILYbOVZD {\n  padding: 15px;\n  width: 100%;\n  border-radius: 10px;\n  border: var(--white-ish) 2px solid;\n}\n", "",{"version":3,"sources":["webpack://./src/components/editor/interfaces/Piano/Piano.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,kCAAkC;AACpC","sourcesContent":[".pianoContainer {\n  padding: 15px;\n  width: 100%;\n  border-radius: 10px;\n  border: var(--white-ish) 2px solid;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pianoContainer": "o7CRax0a8AqwILYbOVZD"
};
export default ___CSS_LOADER_EXPORT___;
